import React, { useContext } from "react"

import CopyButton from "~components/CopyButton"
import MicrocopyContext from "~contexts/MicrocopyContext"
import ExpandButton from "./ExpandButton"

import * as style from "./Generic.module.scss"
import "~css/prism-box.css"

const Generic = ({
  expanded,
  code,
  success,
  config,
  className,
  setExpanded,
  highlighted,
}) => {
  const microcopy = useContext(MicrocopyContext)

  return (
    <div
      data-expanded={expanded}
      data-highlighted={highlighted}
      className={style.block}
    >
      <nav>
        <CopyButton text={code} />
        <ExpandButton
          onClick={() => setExpanded(!expanded)}
          expanded={expanded}
          microcopy={microcopy}
        />
      </nav>
      <pre
        className="line-numbers"
        data-success={success}
        data-line={config.highlight}
      >
        <code className={className}>{code}</code>
      </pre>
    </div>
  )
}

export default Generic
